module.exports = __webpack_public_path__ + "static/knit2-logo-purple-e9937072b4a8b3674154859a0f91fe9d.png";